<template>
  <div class="flex-column bg-img justify-content-start align-items-center position_relative width-90 paddingLr90">
    <div class="paddingTb width-100 margin-ts flex-row justify-content-spaceBetween align-items-star main">
      <div class="width-50" style="border-right: 1px solid #eeeeee; padding-right: 5%; margin-right: 5%">
        <div :class="{ 'from-left': animation2 }" class="width-100 margin-bs swiperBox">
          <!-- Swiper -->
          <van-swipe @change="onChange" class="swiper" width="100%" :autoplay="3000" :show-indicators="false">
            <van-swipe-item
              @click="detail('/newsDetail', item.id, 'news')"
              v-for="(item, index) in commendSwiper"
              :key="index"
              class="swiper-slide position_relative"
            >
              <van-image class="" :src="imagePrefix + item.poster" min-height="350" width="100%" alt="" />
              <div class="masker position_absolute flex-row justify-content-spaceBetween align-items-center" style="">
                <p class="width-60 cutText white textAlign-l">{{ item.title }}</p>
                <div class="width-40 flex-row justify-content-end align-items-center">
                  <span
                    v-for="(item, index) in commendSwiper"
                    :key="index"
                    class="margin-ls span"
                    style="display: inline-block"
                    :style="index === swiperIndex ? 'background: rgba(255, 255, 255, 1)' : 'background: rgba(255, 255, 255, 0.5)'"
                  ></span>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div :class="{ 'from-left1': animation2 }" class="width-100 border-b paddingTb flex-row justify-content-spaceBetween align-items-center">
          <p class="fs-sBig fw-mid black">通知公告</p>
          <img @click="jumpTo('/notice')" src="@/assets/image/right.png" alt="" class="pointer width24" />
        </div>
        <div :class="{ 'from-left2': animation2 }" class="width-100 paddingTb height260">
          <p
            @click="detail('/newsDetail', item.id, 'notice')"
            v-for="(item, index) in NoticeAnnouncement"
            :key="index"
            class="width-100 fs-big lineHeight2 cutText pointer"
          >
            {{ item.title }}
          </p>
        </div>
      </div>
      <div class="width-40">
        <div
          :class="{ 'from-right': animation2 }"
          class="width-100 border-b flex-row justify-content-spaceBetween align-items-center padding-bottom20"
        >
          <p class="fs-sBig fw-mid black">集团动态</p>
          <img @click="jumpTo('/news?Id=0')" src="@/assets/image/right.png" alt="" class="pointer width24" />
        </div>
        <div :class="{ 'from-right': animation2 }" class="width-100 paddingTb height240">
          <p
            @click="detail('/newsDetail', item.id, 'news')"
            v-for="(item, index) in GroupDynamic"
            :key="index"
            :class="index === 0 ? 'fw-mid' : ''"
            class="width-100 pointer fs-big lineHeight2 cutText pointer"
            :style="index === 0 ? 'color: rgb(11, 73, 158)' : ''"
          >
            {{ item.title }}
          </p>
        </div>
        <div
          :class="{ 'from-right1': animation2 }"
          class="width-100 border-b flex-row justify-content-spaceBetween align-items-center padding-bottom20"
        >
          <p class="fs-sBig fw-mid black">辖属动态</p>
          <img @click="jumpTo('/news?Id=1')" src="@/assets/image/right.png" alt="" class="pointer width24" />
        </div>
        <div :class="{ 'from-right1': animation2 }" class="width-100 paddingTb height130">
          <p
            @click="detail('/newsDetail', item.id, 'news')"
            v-for="(item, index) in SubordinateDynamic"
            :key="index"
            class="width-100 fs-big lineHeight2 cutText pointer"
          >
            {{ item.title }}
          </p>
        </div>
        <!--        <div :class="{ 'from-right2': animation2 }" class="width-100 border-b flex-row justify-content-spaceBetween align-items-center" style="padding-bottom: 20px">-->
        <!--          <p class="fs-sBig fw-mid black">媒体报道</p>-->
        <!--          <img @click="jump('/news?Id=2')" src="@/assets/image/right.png" width="24px" alt="" class="pointer" />-->
        <!--        </div>-->
        <!--        <div :class="{ 'from-right2': animation2 }" class="width-100 paddingTb" style="height: 100px">-->
        <!--          <p-->
        <!--            @click="detail('/newsDetail', item.id, 'news')"-->
        <!--            v-for="(item, index) in MediaCoverage"-->
        <!--            :key="index"-->
        <!--            class="width-100 fs-big lineHeight2 cutText pointer"-->
        <!--          >-->
        <!--            {{ item.title }}-->
        <!--          </p>-->
        <!--        </div>-->
      </div>
    </div>
    <!--    <img :class="{ 'from-bottom5': animation2 }" class="bg position_absolute" src="@/assets/image/bg1.jpg" width="100%" alt="" />-->
    <!--    <img class="arrow" src="@/assets/image/arrow1.png" width="40px" alt="" />-->
  </div>
</template>
<script>
import newsApi from '@/api/newsApi';
import config from '@/config';
import Swiper from 'swiper';

export default {
  name: 'page2',
  components: {},
  props: {
    animation2: Boolean
  },
  data() {
    return {
      imagePrefix: config.IMAGE_PREFIX,
      tabCount: 0,
      animation: false,
      tabList: [
        {
          index: 0,
          text: '集团动态'
        },
        {
          index: 1,
          text: '辖属动态'
        },
        {
          index: 2,
          text: '媒体报道'
        }
      ],
      GroupDynamic: [],
      SubordinateDynamic: [],
      MediaCoverage: [],
      NoticeAnnouncement: [],
      commendSwiper: [],
      swiperIndex: 0,

      banner: null,
      bannerUrl: null
    };
  },

  mounted() {
    new Swiper('#page2Swiper', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      }
    });
  },

  created() {
    newsApi
      .list({ status: '1', params: { pageNum: 1, pageSize: 6, likeType: '002' } })
      .then((res) => {
        this.GroupDynamic = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .list({ status: '1', params: { pageNum: 1, pageSize: 6, likeType: '003' } })
      .then((res) => {
        this.SubordinateDynamic = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .list({ status: '1', params: { pageNum: 1, pageSize: 2, likeType: '005' } })
      .then((res) => {
        this.MediaCoverage = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .list({ status: '1', params: { pageNum: 1, pageSize: 6, likeType: '001' } })
      .then((res) => {
        this.NoticeAnnouncement = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    // 推荐
    newsApi
      .list({ isCommend: '1', status: '1', params: { pageNum: 1, pageSize: 3 } })
      .then((res) => {
        this.commendSwiper = res.rows;
      })
      .catch((err) => {
        console.log(err);
      });
    newsApi
      .listType({ indexProject: '1' })
      .then((res) => {
        if (res.data.length > 0) {
          this.banner = res.data[0].indexBanner;
          this.bannerUrl = res.data[0].indexBannerUrl;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    selectTab(e) {
      this.tabCount = e;
    },
    onChange(index) {
      this.swiperIndex = index;
    },
    detail(url, id, type) {
      let text = this.$router.resolve({ path: url, query: { type: type, newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
.bg-img {
  background: url('../assets/image/bg1.jpg') round;
  background-size: cover;
  height: 100vh;
}
.bg {
  bottom: 0;
}
.swiperBox {
  height: 300px;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 350px;
  text-align: center;
}
.tab {
  width: 150px;
}
.width24 {
  width: 24px;
}
.height240 {
  height: 240px;
}
.height130 {
  height: 130px;
}
.height260 {
  height: 260px;
}
.padding-bottom20 {
  padding-bottom: 20px;
}

.titImg {
  left: 0;
  top: -0px;
}
.titBox {
  margin: 30px 0;
}
.tit {
  width: 95%;
  padding: 0 0 0 15%;
  line-height: 55px;
  border-bottom: 1px solid rgba(11, 73, 158, 0.2);
}
.maxWidth {
  max-width: 80%;
}
.span {
  width: 10px;
  height: 4px;
}

//.arrow {
//  margin: 100px 48.5% 0 !important;
//}
.fixed_r {
  top: 45%;
}
.masker {
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  padding: 10px 3%;
  width: 94%;
}
.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.arrow {
  margin: 0 0 100px 0 !important;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.from-left {
  position: relative;
  animation: left 0.5s 0s ease-in-out;
  -moz-animation: left 0.5s 0s ease-in-out; /* Firefox */
  -webkit-animation: left 0.5s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: left 0.5s 0s ease-in-out; /* Opera */
}
.from-left1 {
  position: relative;
  animation: left 0.8s 0s ease-in-out;
  -moz-animation: left 0.8s 0s ease-in-out; /* Firefox */
  -webkit-animation: left 0.8s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: left 0.8s 0s ease-in-out; /* Opera */
}
.from-left2 {
  position: relative;
  animation: left 1s 0s ease-in-out;
  -moz-animation: left 1s 0s ease-in-out; /* Firefox */
  -webkit-animation: left 1s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: left 1s 0s ease-in-out; /* Opera */
}
@keyframes left {
  0% {
    left: -500px;
  }
  50% {
    left: 50px;
  }
  100% {
    left: 0;
  }
}

@-moz-keyframes left /* Firefox */ {
  0% {
    left: -500px;
  }
  50% {
    left: 50px;
  }
  100% {
    left: 0;
  }
}

@-webkit-keyframes left /* Safari and Chrome */ {
  0% {
    left: -500px;
  }
  50% {
    left: 50px;
  }
  100% {
    left: 0;
  }
}

@-o-keyframes left /* Opera */ {
  0% {
    left: -500px;
  }
  50% {
    left: 50px;
  }
  100% {
    left: 0;
  }
}
.from-right {
  position: relative;
  animation: right 0.5s 0s ease-in-out;
  -moz-animation: right 0.5s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 0.5s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 0.5s 0s ease-in-out; /* Opera */
}
.from-right1 {
  position: relative;
  animation: right 0.8s 0s ease-in-out;
  -moz-animation: right 0.8s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 0.8s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 0.8s 0s ease-in-out; /* Opera */
}
.from-right2 {
  position: relative;
  animation: right 1s 0s ease-in-out;
  -moz-animation: right 1s 0s ease-in-out; /* Firefox */
  -webkit-animation: right 1s 0s ease-in-out; /* Safari and Chrome */
  -o-animation: right 1s 0s ease-in-out; /* Opera */
}
@keyframes right {
  0% {
    right: -500px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-moz-keyframes right /* Firefox */ {
  0% {
    right: -500px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-webkit-keyframes right /* Safari and Chrome */ {
  0% {
    right: -500px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}

@-o-keyframes right /* Opera */ {
  0% {
    right: -500px;
  }
  50% {
    right: 50px;
  }
  100% {
    right: 0;
  }
}
</style>
<style>
.van-notice-bar__content.van-ellipsis {
  max-width: 100%;
}
.van-notice-bar {
  background: rgba(0, 0, 0, 0);
}
</style>
